export default {
    data() {
        return {
            parsed: null,
            svg: null,
            spz: null,
            width: 0,
            height: 0,
            totalLength: 0,
            fullArea: 0,
            closedLines: 0,
            notClosedLines: 0,
            scale: 100
        }
    },
    methods: {
        isPointInPoly(poly, pt) {
            for (var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
                ((poly[i].y <= pt.y && pt.y < poly[j].y) || (poly[j].y <= pt.y && pt.y < poly[i].y))
                && (pt.x < (poly[j].x - poly[i].x) * (pt.y - poly[i].y) / (poly[j].y - poly[i].y) + poly[i].x)
                && (c = !c)
            return c
        },
        areaFromCoords(t) {
            let e = 0;
            for (let n = t.length, a = 0; a < n; a += 1) {
                let i = t[a],
                    r = t[(a - 1 + n) % n];
                e += (r.x + i.x) * (r.y - i.y)
            }
            return Math.abs(e / 2)
        },
        polygonSampledFromPath(t) {
            let n = t.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "polygon")
            let	p = t.getAttribute('d')

            p = p.replace('M','')
            p = p.replace('Z','') //Removes close path command
            let a = p.split('L')		
                                                
            return n.setAttribute("points", a.join(" ")), n
        },
        calculateFullArea(pathList) {
            let totalArea = 0.0		
            let polygons = []
            for (let i=0, l = pathList.length; i < l; i++) {
                polygons.push(this.polygonSampledFromPath(pathList[i]))		
            }

            for (let i=0, l = pathList.length; i < l; i++) {				
                let ar = this.areaFromCoords(polygons[i].points)
                let point = polygons[i].points[0]
                let insideCount = 0
                for (let j = 0; j < l; j++) {
                    //Do no compare to itseft
                    if (j == i) {						
                        continue
                    }
                    if (this.isPointInPoly(polygons[j].points, point)) {
                        insideCount++				
                    }
                }
                if (insideCount % 2) {
                    ar = ar * (-1)
                }
                
                totalArea += ar
            }

            return totalArea
        },
        getDistance(point1, point2) {
            let xs = 0
            let ys = 0
            
            xs = point2.x - point1.x
            xs = xs * xs
            
            ys = point2.y - point1.y
            ys = ys * ys
            
            return Math.sqrt(xs + ys)
        },
        reversePath(p) {									
            p = p.replace('M','')	
            let a = p.split('L')		
            a.reverse()		
            let p2 = a.join('L')
            let m = 'M'
            p2 = m.concat(p2)
            return p2
        },
        removeM(p) {
            p = p.replace('M','')
            let a = p.split('L')
            a.shift()
            let p2 = a.join('L')
            let l = 'L'
            p2 = l.concat(p2)
            return p2
        },
        unitePaths(svg, tolerance) {			
            let $s =  $(svg)
            let $pl = $s.find('path')						
            
            let united = false;			
            for (let i = 0, l = $pl.length; i < l; i++) {	
                                
                let t1 = $pl[i].getTotalLength()
                let p1 = $pl[i].getPointAtLength(0.0)
                let p2 = $pl[i].getPointAtLength(t1)																
                
                //check if the path is closed already
                let p1p2 = this.getDistance(p1, p2)
                if (p1p2 < tolerance) {
                    continue
                }
                
                for (let j = i + 1; j < l; j++) {
                    let t2 = $pl[j].getTotalLength()
                    let p3 = $pl[j].getPointAtLength(0.0)									
                    let p4 = $pl[j].getPointAtLength(t2)																		
                    
                    //> 1e-5					
                    let p2p3 = this.getDistance(p2, p3)
                    let p2p4 = this.getDistance(p2, p4)
                    let p1p4 = this.getDistance(p1, p4)
                    let p1p3 = this.getDistance(p1, p3)									
                        
                    if (p2p3 < tolerance || p2p4 < tolerance || p1p4 < tolerance || p1p3 < tolerance) {
                        if (p2p3 < tolerance) {
                            let path1 = $pl[i].getAttribute('d')
                            let path2 = this.removeM($pl[j].getAttribute('d'))					
                            $pl[i].setAttribute('d', path1 + path2)
                        } else if(p2p4 < tolerance) {
                            let path1 = $pl[i].getAttribute('d')
                            let path2 = this.reversePath($pl[j].getAttribute('d'))
                            path2 = this.removeM(path2)
                            $pl[i].setAttribute('d', path1 + path2);							
                        } else if (p1p3 < tolerance) {
                            let path1 = this.reversePath($pl[j].getAttribute('d'))
                            let path2 = this.removeM($pl[i].getAttribute('d'))
                            $pl[i].setAttribute('d', path1 + path2)
                        } else if (p1p4 < tolerance) {
                            let path1 = $pl[j].getAttribute('d')
                            let path2 = this.removeM($pl[i].getAttribute('d'))
                            $pl[i].setAttribute('d', path1 + path2)
                        }
                                                
                        $pl[j].setAttribute('class', 'to-remove')					
                        united = true
                        break		
                    }
                                
                }
                                                
                if (united) {
                    break
                }				
            }
            
            if (united) {
                let $r = $s.find('.to-remove')
                $r.remove()
                return this.unitePaths($('<div>').append($s).html(), tolerance)
            } else {
                this.closedLines = 0
                this.notClosedLines = 0
                for (let i = 0, l = $pl.length; i < l; i++) {	
                    let t1 = $pl[i].getTotalLength()
                    let p1 = $pl[i].getPointAtLength(0.0)
                    let p2 = $pl[i].getPointAtLength(t1)
                    //if the path is Not closed
                    let d = this.getDistance(p1, p2)
                    if (d >= tolerance) {
                        this.notClosedLines++
                        $pl[i].setAttribute('stroke', 'green')
                    } else {
                        //Add close path 'Z' command
                        $pl[i].setAttribute('d', $pl[i].getAttribute('d').concat('Z'))
                        $pl[i].setAttribute('class', 'closed-path')
                        this.closedLines++															
                    }
                    
                    // $($pl[i]).append('<title>' + d + ' ' + i +': (' + p1.x + ', '+ p1.y + ')(' + p2.x + ', '+ p2.y + ')</title>')
                }

                return $('<div>').append($s).html()
            }														
        }
    }
}